import { NftDetail, NftItem } from '../../models'

interface NFTDTOBase {
    animation_url: string
    description: string
    id: string
    image_url: string
    name: string
    owner: string
    tags: string[]
    token_address: string
    token_id: string
    type: string
    upload: boolean
}

export interface NftItemDto extends NFTDTOBase {
    image_original_url: string
    image_preview_url: string
    is_valid: number
}

export const convertToNftItem = (dto: NftItemDto): NftItem => {
    return {
        ...dto
    }
}

export interface NftDetailDto extends NFTDTOBase {
    animation_subtype: string
    details_loaded: boolean
    external_url: string
    image: string
    source: string
}

export const convertToNftDetail = (dto: NftDetailDto): NftDetail => {
    return {
        ...dto,
        tags: dto?.tags ? dto.tags : []
    }
}
